export default "__VITE_ASSET__C7nd2VCM__"